import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "i18n";

export class Controls extends Component {
  /*componentDidUpdate(prevProps, prevState) {
    const { updated, saveCallback } = this.props;

    if (updated) {
      saveCallback();
    }
  }*/

  handleCancel() {
    /*const { closeDiv, closeDivType, onCancel } = this.props;

    if (typeof onCancel === "function") {
      onCancel();
      return;
    }

    const clDiv =
      closeDivType === "id"
        ? document.getElementById(closeDiv)
        : document.getElementsByClassName(closeDiv).item(0);
    clDiv.click();*/
  }

  /*handleOk() {
    const { dispatch, action } = this.props;
    dispatch(action());
  }*/

  renderBtnOK() {
    const {
      updating,
      updated,
      ok,
      action,
      successMessage,
      progressMessage
    } = this.props;
    if (updating) {
      $(".controls").addClass("saving");
      return (
        <button className="controls__ok">
          {progressMessage ? progressMessage : _("updating in progress...")}
          <i className="icon icon-refresh" />
        </button>
      );
    }
    $(".controls").removeClass("saving");
    if (updated) {
      return (
        <button className="controls__ok" onClick={() => this.handleCancel()}>
          {successMessage ? successMessage : _("Successfully updated!")}
          <i className="icon icon-like" />
        </button>
      );
    }
    return (
      <button className="controls__ok" onClick={action}>
        {ok}
      </button>
    );
  }

  render() {
    const { cancel, label, className } = this.props;

    return (
      <div id="controls" className={className ? className : "default"}>
        <button
          className="controls__cancel"
          onClick={this.handleCancel.bind(this)}
        >
          {cancel}
        </button>
        <div className="controls__label">{label}</div>
        {this.renderBtnOK()}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Controls);



// WEBPACK FOOTER //
// ./src/components/Settings/Controls.js